import { useTranslation } from "@msuite/ui/localization";
import { UserCard } from "@/components/cards";
import type { ApprovalRow } from "./approval-row";

/** Props Interface */
interface ApprovalAssignmentCellProps {
	approval: ApprovalRow;
}

/**
 * How the person came to be asked: as a default approver, or handed the invoice by the member
 * shown. Whether a handover is the sole approval has a column of its own.
 */
export function ApprovalAssignmentCell({ approval }: ApprovalAssignmentCellProps) {
	/** Context */
	const { t } = useTranslation();

	/** Render */
	if (approval.assignment === "default") {
		return <span className="label">{t("incoming_invoices.handover.default_approver")}</span>;
	}
	// A handover names who handed it over; one whose author is gone falls back to the word.
	if (!approval.assignedBy) {
		return <span className="label">{t("incoming_invoices.handover.handed_over")}</span>;
	}
	return (
		<UserCard
			userId={approval.assignedBy}
			variant="plain"
		/>
	);
}
